import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

const drawerWidth = 240;
const navItems = [
  { 
    title: 'Home',
    path: '/home' 
  }, 
  { 
    title: 'Mac',
    path: '/mac/home' 
  }, 
  {
    title: 'Search Extended Warranty Registration',
    path: '/search-extended-warranty-registration' 
  }, 
  {
    title: 'Terms & Conditions',
    path: '/terms-and-conditions' 
  }];

function DrawerAppBar(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center'}}>
      <div style={{ flexGrow: 1, flexDirection: "row", display: "flex", backgroundColor: "black", padding: 30 }}>
          <img src='/assets/logo.svg' alt='genxt logo' height={30}/>
          <img src='/assets/apple-authorized-logo.svg' alt='Apple  Authorized Distributor logo' height={30} style={{ marginLeft: 20}}/>
          </div>
      <Divider />
      <List style={{ padding: 15 }} >
        {navItems.map((item) => (
          <ListItem key={item.title} disablePadding>
            <ListItemButton  href={item.path}  sx={{ textAlign: 'left' }}>
              <Typography style={{ fontWeight: 100, fontSize: 14, color: '#cecece' }}>
                  {item.title}
              </Typography>
            </ListItemButton>
            
          </ListItem>
        ))}
      </List>
    </Box>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar component="nav" sx={{  display: "flex", alignItems: "center", backgroundColor: "black",boxShadow: 'none', borderBottom: ".5px solid rgb(57, 57, 60)" }} >
     
        <Toolbar sx={{ backgroundColor: "black", maxWidth: 1200, width: "100%"   }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>

          
          <div  style={{ flexGrow: 1, flexDirection: "row", display: "flex" }}>
          <Link href="/home"><img src='/assets/genxt_logo_authorized_distributor.png' alt='genxt logo' height={40}/></Link>
          </div>
          
          
          
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            {navItems.map((item) => (
              <Button key={item.title} href={item.path} sx={{ color: '#cecece', fontWeight: 100 }}>
                {item.title}
              </Button>
            ))}
          </Box>
          
        </Toolbar>
        
      </AppBar>
      <nav>
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
      
    </Box>
    
  );
}

DrawerAppBar.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default DrawerAppBar;